import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/user';
// import { Task } from 'src/app/models/task';

@Component({
  selector: 'app-modal-edit-technician-task',
  template: `
    <ng-template #modalEditTechnicianTask let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Edit Technician Task</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <p>Content for editing technician task goes here.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="button" class="btn btn-primary" (click)="modal.close()">Save changes</button>
      </div>
    </ng-template>
  `,
  styles: ``
})
export class ModalEditTechnicianTaskComponent implements AfterViewInit {
  @Input() task: any; // Task | null = null;
  @Input() technicians: User[] = [];
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalEditTechnicianTask') modalEditTechnicianTask !: ElementRef;

  private modalRef: NgbModalRef | undefined;

  constructor(
    private modalService: NgbModal,
  ) {}

  ngAfterViewInit(): void {}

  openModal(modalContent: TemplateRef<any>) {
    console.log('openModal');
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
